import { render, staticRenderFns } from "./PromptPayCard.vue?vue&type=template&id=b03a1e8c&scoped=true"
import script from "./PromptPayCard.vue?vue&type=script&lang=js"
export * from "./PromptPayCard.vue?vue&type=script&lang=js"
import style0 from "./PromptPayCard.vue?vue&type=style&index=0&id=b03a1e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03a1e8c",
  null
  
)

export default component.exports